<template>
<div class="healthReportBox">
    <div class="reportPage one_page">
        <div class="fmTitle">
            <div class="rbTitText">
                <img src="@/assets/u2.png" alt="">
                <h1>健康评估报告</h1>
            </div>
            <div class="englishText">Health Assessment Report</div>
        </div>

        <table class="infoTable">
            <tr>
                <td>姓名:</td>
                <td>{{healthReportInfo.user_name}}</td>
            </tr>
            <tr>
                <td>性别:</td>
                <td>
                    <span>{{healthReportInfo.sex}}</span>
                </td>
            </tr>
            <tr>
                <td>年龄:</td>
                <td>{{healthReportInfo.age}}岁</td>
            </tr>
            <tr>
                <td>身份证号:</td>
                <td>{{healthReportInfo.id_card}}</td>
            </tr>
            <tr>
                <td>单位:</td>
                <td>{{healthReportInfo.unit}}</td>
            </tr>
            <tr>
                <td>体检时间:</td>
                <td>{{healthReportInfo.createTime}}</td>
            </tr>
            <tr>
                <td>检出风险项:</td>
                <td>{{healthReportInfo.count}}项</td>
            </tr>
        </table>
    </div>
    <div class="reportPage two_page">
        <div class="modelTwoTit">生理指标</div>
        <div class="modelItem">
            <table class="itemTable">
                <tr>
                    <td style="width: 140px;">检查项</td>
                    <td style="width: 175px;">检查结果</td>
                    <td style="width: 160px;">状态</td>
                    <td>参考范围</td>
                </tr>
                <tr>
                    <td>心率</td>
                    <td>{{healthReportInfo.hr}}（次/分）</td>
                    <td v-if="healthReportInfo.hr_state == 0" style="color: red;font-weight: bold;">心率过缓</td>
                    <td v-else-if="healthReportInfo.hr_state == 1" style="color: #06a506;font-weight: bold;">正常</td>
                    <td v-else-if="healthReportInfo.hr_state == 2" style="color: red;font-weight: bold;">心率过快</td>
                    <td>60~100</td>
                </tr>
                <tr>
                    <td class="longText" colspan="4"><span style="color: #06a506;">说明:</span>心率是指正常人安静状态下每分钟心跳的次数，也叫安静心率，一般为 60~100 次/分，可因年龄、性别或其他生理因素产生个体差异。</td>
                </tr>
                <tr>
                    <td class="longText" colspan="4"><span style="color: #06a506;">分析:</span>{{healthReportInfo.hr_idea}}</td>
                </tr>
                <tr>
                    <td>呼吸</td>
                    <td>{{healthReportInfo.br_face}}(次/分)</td>
                    <td v-if="healthReportInfo.br_face_state == 0" style="color: red;font-weight: bold;">呼吸过缓</td>
                    <td v-else-if="healthReportInfo.br_face_state == 1" style="color: #06a506;font-weight: bold;">正常</td>
                    <td v-else-if="healthReportInfo.br_face_state == 2" style="color: red;font-weight: bold;">呼吸过速</td>
                    <td>12~20</td>
                </tr>
                <tr>
                    <td class="longText" colspan="4"><span style="color: #06a506;">说明:</span>呼吸频率为一种形容每分钟呼吸的次数的医学术语每分钟呼吸的次数称为呼吸频率。正常成人呼吸 频率为每分钟 12~20 次。</td>
                </tr>
                <tr>
                    <td class="longText" colspan="4"><span style="color: #06a506;">分析:</span>{{healthReportInfo.br_face_idea}}</td>
                </tr>
                <tr>
                    <td>血氧</td>
                    <td>{{healthReportInfo.spo2}}(%)</td>
                    <td v-if="healthReportInfo.spo2_state == 0" style="color: red;font-weight: bold;">供氧不足</td>
                    <td v-else-if="healthReportInfo.spo2_state == 1" style="color: #06a506;font-weight: bold;">正常</td>
                    <td v-else-if="healthReportInfo.spo2_state == 2" style="color: red;font-weight: bold;">严重供养不足</td>
                    <td>94~100</td>
                </tr>
                <tr>
                    <td class="longText" colspan="4"><span style="color: #06a506;">说明:</span>血氧饱和度(Sa02)是血液中被氧结合的氧合血红蛋白(Hb02)的容量占全部可结合的血红蛋白(Hb，hemoglobin)容量的百分比，即血液中血氧的浓度，它是呼吸循环的重要生理参数，血液携带输送氧 气的能力即用血氧饱和度来衡量，正常人体动脉血的血氧饱和度为 94%~100%。</td>
                </tr>
                <tr>
                    <td class="longText" colspan="4"><span style="color: #06a506;">分析:</span>{{healthReportInfo.spo2_idea}}</td>
                </tr>
            </table>
        </div>
    </div>
    <div class="reportPage two_page">
        <div class="showPrintModel" style="height: 30px;"></div>
        <div class="noPrintModel" style="height: 20px;"></div>
        <div class="modelItem">
            <table class="itemTable">
                <tr>
                    <td style="width: 140px;">收缩压</td>
                    <td style="width: 175px;">{{healthReportInfo.bp_h}}(mmHg)</td>
                    <td v-if="healthReportInfo.bp_h_state == 0" style="width: 160px;color: red;font-weight: bold;">低血压</td>
                    <td v-else-if="healthReportInfo.bp_h_state == 1" style="width: 160px;color: #06a506;font-weight: bold;">正常</td>
                    <td v-else-if="healthReportInfo.bp_h_state == 2" style="width: 160px;color: red;font-weight: bold;">偏高</td>
                    <td v-else-if="healthReportInfo.bp_h_state == 3" style="width: 160px;color: red;font-weight: bold;">高血压</td>
                    <td >90~135</td>
                </tr>
                <tr>
                    <td class="longText" colspan="4"><span style="color: #06a506;">说明:</span>收缩压是当人的心脏收缩时，动脉内的压力上升，心脏收缩的中期，动脉内压力最高，此时血液对血管内壁的压力称为收缩压，亦称高压。根据《中国高血压指南》，90~119 称为正常血压，120~139
                        称为正常高值。140 以上称为高血压。</td>
                </tr>
                <tr>
                    <td class="longText" colspan="4"><span style="color: #06a506;">分析:</span>{{healthReportInfo.bp_h_idea}}</td>
                </tr>
                <tr>
                    <td>舒张压</td>
                    <td>{{healthReportInfo.bp_l}}(mmHg)</td>
                    <td v-if="healthReportInfo.bp_l_state == 0" style="color: red;font-weight: bold;">低血压</td>
                    <td v-else-if="healthReportInfo.bp_l_state == 1" style="color: #06a506;font-weight: bold;">正常</td>
                    <td v-else-if="healthReportInfo.bp_l_state == 2" style="color: red;font-weight: bold;">偏高</td>
                    <td v-else-if="healthReportInfo.bp_l_state == 3" style="color: red;font-weight: bold;">高血压</td>
                    <td>60~85</td>
                </tr>
                <tr>
                    <td class="longText" colspan="4"><span style="color: #06a506;">说明:</span>舒张压就是当人的心脏舒张时，动脉血管弹性回缩，87产生的压力称为舒张压，又叫低压。根据《2020
                    国际高血压学会全球高血压实践指南》：成人正常的舒张压为＜85mmHg 。具体来说，低于 85 称
                    为正常值，85~89 称为正常高值，低压≥90 称为高血压。其中，90～99 属 1 级高血压，＞100 属 2
                    级高血压</td>
                </tr>
                <tr>
                    <td class="longText" colspan="4"><span style="color: #06a506;">分析:</span>{{healthReportInfo.bp_l_idea}}</td>
                </tr>
                
                <tr>
                    <td>实时精神状态</td>
                    <td></td>
                    <td style="color: #06a506;font-weight: bold;" v-if="healthReportInfo.instant_status == 0">清醒</td>
                    <td style="color: red;font-weight: bold;" v-else-if="healthReportInfo.instant_status == 1">焦虑</td>
                    <td style="color: red;font-weight: bold;" v-else-if="healthReportInfo.instant_status == 2">生理疲劳</td>
                    <td style="color: red;font-weight: bold;" v-else-if="healthReportInfo.instant_status == 3">昏昏欲睡</td>
                    <td></td>
                </tr>
                <tr>
                    <td class="longText" colspan="4"><span style="color: #06a506;">说明:</span>产生于自主神经系统对心脏窦房结的调剂，这种微小差异变化能够反映自主神经系统活性及其平衡协调的关系从而客观的反映大脑所承受的实时精神状态。</td>
                </tr>
            </table>
        </div>
    </div>
    <div class="reportPage two_page">
        <div class="showPrintModel" style="height: 40px"></div>
        <div class="noPrintModel" style="height: 20px;"></div>
        <div class="modelItem">
            <table class="itemTable">
                <tr>
                    <td>血糖</td>
                    <td>{{healthReportInfo.dm_value_}}(mmol/L)</td>
                    <td v-if="healthReportInfo.dm_value_state == 0" style="color: red;font-weight: bold;">学糖偏低</td>
                    <td v-else-if="healthReportInfo.dm_value_state == 1" style="color: #06a506;font-weight: bold;">正常</td>
                    <td v-else-if="healthReportInfo.dm_value_state == 2" style="color: red;font-weight: bold;">血糖偏高</td>
                    <td>4.4~7.8</td>
                </tr>
                <tr>
                    <td class="longText" colspan="4"><span style="color: #06a506;">说明:</span>血液中的葡萄糖称为血糖，血糖值单位为 mmol/L。餐后两小时血糖
                        正常范围一般在 4.4~7.8mmol/L。</td>
                </tr>
                <tr>
                    <td class="longText" colspan="4"><span style="color: #06a506;">分析:</span>{{healthReportInfo.dm_value_idea}}</td>
                </tr>
                
                <tr>
                    <td>长期压力</td>
                    <td></td>
                    <td v-if="healthReportInfo.pressure_index === 0">低</td>
                    <td v-else-if="healthReportInfo.pressure_index === 1">正常</td>
                    <td v-else-if="healthReportInfo.pressure_index === 2">中</td>
                    <td v-else-if="healthReportInfo.pressure_index === 3">高</td>
                    <td v-else></td>
                    <td></td>
                </tr>
                <tr>
                    <td class="longText" colspan="4"><span style="color: #06a506;">说明:</span>长期压力:HRV(心率变异性)产生于自主神经系统对心脏窦房结的调剂，这种微小差异变化能够反映 自主神经系统活性及其平衡协调的关系，从而客观的反映大脑所承受的压力。</td>
                </tr>
                <tr>
                    <td>机能活性</td>
                    <td></td>
                    <td v-if="healthReportInfo.active_level === 0">低</td>
                    <td v-else-if="healthReportInfo.active_level === 1">中</td>
                    <td v-else-if="healthReportInfo.active_level === 2">高</td>
                    <td v-else></td>
                    <td></td>
                </tr>
                <tr>
                    <td class="longText" colspan="4"><span style="color: #06a506;">说明:</span>机能活性度:通过对HRV(心率变异性)的分析，可以反映出自主神经系统整体的活性，用于评估自主神经系统的调节能力。</td>
                </tr>
                <tr>
                    <td style="width: 140px;">恢复能力</td>
                    <td style="width: 175px;"></td>
                    <td v-if="healthReportInfo.pressure_index === 0">低</td>
                    <td v-else-if="healthReportInfo.pressure_index === 1">中</td>
                    <td v-else-if="healthReportInfo.pressure_index === 2">高</td>
                    <td v-else></td>
                    <td></td>
                </tr>
                <tr>
                    <td class="longText" colspan="4"><span style="color: #06a506;">说明:</span>恢复能力:通过对 HRV(心率变异性)的分析，可以反映神经系统从异常状态恢复到正常状态的能力，值越大，代表身体的恢复能力越强。</td>
                </tr>

                <tr>
                    <td style="width: 140px;">机能年龄</td>
                    <td style="width: 175px;">{{healthReportInfo.phy_age}}</td>
                    <td style="width: 160px;"></td>
                    <td></td>
                </tr>
                <tr>
                    <td style="width: 140px;">糖尿病风险</td>
                    <td style="width: 175px;"></td>
                    <td style="width: 160px;">
                        <span style="color: #06a506;font-weight: bold;" v-if="healthReportInfo.dm_risk_ === 0">低</span>
                        <span style="color: red;font-weight: bold;" v-else-if="healthReportInfo.dm_risk_ === 1">中</span>
                        <span style="color: red;font-weight: bold;" v-else-if="healthReportInfo.dm_risk_ === 2">高</span>
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td style="width: 140px;">心血管风险</td>
                    <td style="width: 175px;"></td>
                    <td style="width: 160px;">
                        <span style="color: #06a506;font-weight: bold;" v-if="healthReportInfo.cardiovascular_risk === 0">低</span>
                        <span style="color: red;font-weight: bold;" v-else-if="healthReportInfo.cardiovascular_risk === 1">中</span>
                        <span style="color: red;font-weight: bold;" v-else-if="healthReportInfo.cardiovascular_risk === 2">高</span>
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td style="width: 140px;">心率变异性</td>
                    <td style="width: 175px;">{{healthReportInfo.hrv_change}}</td>
                    <td style="width: 160px;"></td>
                    <td></td>
                </tr>

                <tr>
                    <td style="width: 140px;">身高</td>
                    <td style="width: 175px;">{{healthReportInfo.height}}(cm)</td>
                    <td style="width: 160px;"></td>
                    <td></td>
                </tr>
                <tr>
                    <td>体重</td>
                    <td>{{healthReportInfo.weight}}(kg)</td>
                    <td>
                        <span v-if="healthReportInfo.hwBmiState === 1">偏瘦</span>
                        <span v-else-if="healthReportInfo.hwBmiState === 2" style="color: #06a506;font-weight: bold;">正常</span>
                        <span v-else-if="healthReportInfo.hwBmiState === 3">超重</span>
                        <span v-else-if="healthReportInfo.hwBmiState === 4">肥胖</span>
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td>左眼视力</td>
                    <td>{{healthReportInfo.leftEyesight}}</td>
                    <td>
                        <span v-if="healthReportInfo.leftEyesightState === 1">偏高</span>
                        <span v-else-if="healthReportInfo.leftEyesightState === 2">偏低</span>
                        <span v-else-if="healthReportInfo.leftEyesightState === 3" style="color: #06a506;font-weight: bold;">正常</span>
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td>右眼视力</td>
                    <td>{{healthReportInfo.rightEyesight}}</td>
                    <td>
                        <span v-if="healthReportInfo.rightEyesightState === 1">偏高</span>
                        <span v-else-if="healthReportInfo.rightEyesightState === 2">偏低</span>
                        <span v-else-if="healthReportInfo.rightEyesightState === 3" style="color: #06a506;font-weight: bold;">正常</span>
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td>体温</td>
                    <td>{{healthReportInfo.templature}}(℃)</td>
                    <td>
                        <span v-if="healthReportInfo.templatureState === 1" style="color: red;font-weight: bold;">偏高</span>
                        <span v-else-if="healthReportInfo.templatureState === 2" style="color: red;font-weight: bold;">偏低</span>
                        <span v-else-if="healthReportInfo.templatureState === 3" style="color: #06a506;font-weight: bold;">正常</span>
                    </td>
                    <td>36.5~37.5</td>
                </tr>
                <tr>
                    <td>脂肪率</td>
                    <td>{{healthReportInfo.fatRate}}(%)</td>
                    <td>
                        <span v-if="healthReportInfo.fatRateState === 1" style="color: red;font-weight: bold;">偏高</span>
                        <span v-else-if="healthReportInfo.fatRateState === 2" style="color: red;font-weight: bold;">偏低</span>
                        <span v-else-if="healthReportInfo.fatRateState === 3" style="color: #06a506;font-weight: bold;">正常</span>
                    </td>
                    <td>18.0~28.0</td>
                </tr>
            </table>
        </div>
    </div>
    <div class="reportPage three_page">
        <div class="noPrintModel" style="height: 20px;"></div>
        <div class="modelThreeTit">身心健康建议</div>
        <table class="fxTable">
            <tr>
                <td>机能年龄</td>
                <td>糖尿病风险</td>
                <td>心血管风险</td>
                <td>机能活性度</td>
                <td>恢复能力</td>
                <td>长期压力</td>
            </tr>
            <tr>
                <td style="color: #06a506;font-weight: bold;">{{healthReportInfo.phy_age}}</td>
                <td>
                    <span style="color: #06a506;font-weight: bold;" v-if="healthReportInfo.dm_risk_ === 0">低</span>
                    <span style="color: red;font-weight: bold;" v-else-if="healthReportInfo.dm_risk_ === 1">正常</span>
                    <span style="color: red;font-weight: bold;" v-else-if="healthReportInfo.dm_risk_ === 2">高</span>
                </td>
                <td>
                    <span style="color: #06a506;font-weight: bold;" v-if="healthReportInfo.cardiovascular_risk === 0">低</span>
                    <span style="color: red;font-weight: bold;" v-else-if="healthReportInfo.cardiovascular_risk === 1">中</span>
                    <span style="color: red;font-weight: bold;" v-else-if="healthReportInfo.cardiovascular_risk === 2">高</span> 
                </td>
                <td>
                    <span style="color: #06a506;font-weight: bold;" v-if="healthReportInfo.active_level === 0">低</span>
                    <span style="color: red;font-weight: bold;" v-else-if="healthReportInfo.active_level === 1">中</span>
                    <span style="color: red;font-weight: bold;" v-else-if="healthReportInfo.active_level === 2">高</span>
                </td>
                <td>
                    <span style="color: #06a506;font-weight: bold;" v-if="healthReportInfo.pressure_index === 0">低</span>
                    <span style="color: red;font-weight: bold;" v-else-if="healthReportInfo.pressure_index === 1">中</span>
                    <span style="color: red;font-weight: bold;" v-else-if="healthReportInfo.pressure_index === 2">高</span>
                </td>
                <td>
                    <span style="color: #06a506;font-weight: bold;" v-if="healthReportInfo.pressure_index === 0">低</span>
                    <span style="color: red;font-weight: bold;" v-else-if="healthReportInfo.pressure_index === 1">中</span>
                    <span style="color: red;font-weight: bold;" v-else-if="healthReportInfo.pressure_index === 2">高</span>
                </td>
            </tr>
        </table>
        <div class="suggestedText">
            <ul>
                <li>心率变异性（HRV）是指窦性心律在一定时间内周期性改变的现象，是反应交感神经与副交感神经张力和平衡的重要指标，它是一项无创伤检查技术，HRV 信号中蕴含了有关心血管调节的大量信息，对这些信息的提取和分析可以定量评估心脏交感神经和副交感神经活动的影响。简单来说，心率变异性越高，就意味着心脏能够越快的适应内部和外部带来的影响，即机体对环境变化的适应程度越好。反之，则表明机体对环境的适应能力越差，并可能暗示严重的健康损害。例如：心血管疾病、精神疾病、神经病或癌症等等。</li>
                <li>机能年龄：通过对 HRV(心率变异性)的分析，可以得出人体体质的老化程度。系统检测到您的机能年龄为{{healthReportInfo.phy_age}}岁，代表您的身体体质处于
                    <span v-if="healthReportInfo.phy_age<=40">正常</span>
                    <span v-else-if="healthReportInfo.phy_age<=70">中度衰老</span>
                    <span v-else-if="healthReportInfo.phy_age<=100">严重衰老</span> 状态</li>
                <li>精神状态：通过对 HRV 等指标的分析，可以得出被测人当前的精神状态。系统检测到您当前的精神状态为
                    <span v-if="healthReportInfo.instant_status == 0">清醒</span>
                    <span v-else-if="healthReportInfo.instant_status == 1">焦虑</span>
                    <span v-else-if="healthReportInfo.instant_status == 2">生理疲劳</span>
                    <span v-else-if="healthReportInfo.instant_status == 3">昏昏欲睡</span></li>
                <li>机能活性度：通过对 HRV(心率变异性)的分析，可以反映出自主神经系统整体的活性，用于评估自主
                    神经系统的调节能力。系统检测到您的机能活性度为
                    <span v-if="healthReportInfo.active_level === 0">低</span>
                    <span v-else-if="healthReportInfo.active_level === 1">中</span>
                    <span v-else-if="healthReportInfo.active_level === 2">高</span>。</li>
                <li>恢复能力：通过对 HRV(心率变异性)的分析，可以反映神经系统从异常状态恢复到正常状态的能力，
                    值越大，代表身体的恢复能力越强。系统检测到您的恢复能力为
                    <span v-if="healthReportInfo.pressure_index === 0">低</span>
                    <span v-else-if="healthReportInfo.pressure_index === 1">中</span>
                    <span v-else-if="healthReportInfo.pressure_index === 2">高</span>。</li>
                <li>长期压力：HRV(心率变异性) 产生于自主神经系统对心脏窦房结的调剂，这种微小差异变化能够反映
                    自主神经系统活性及其平衡协调的关系，从而客观的反映大脑所承受的压力。系统检测到您的长期压力为
                    <span v-if="healthReportInfo.pressure_index === 0">低</span>
                    <span v-else-if="healthReportInfo.pressure_index === 1">中</span>
                    <span v-else-if="healthReportInfo.pressure_index === 2">高</span>。</li>
                <li>心血管风险：通过对 HRV(心率变异性)的分析，可以反映交感神经功能亢进、副交感神经活性减弱等信息。
                    这些是高血压、心肌梗死、心脏性猝死等疾病预测的重要依据。系统检测到您患心血管疾病的风险为
                    <span v-if="healthReportInfo.cardiovascular_risk === 0">低</span>
                    <span v-else-if="healthReportInfo.cardiovascular_risk === 1">中</span>
                    <span v-else-if="healthReportInfo.cardiovascular_risk === 2">高</span>。</li>
                <li>糖尿病风险：表示处于糖尿病前期或者患有糖尿病的可能性。系统检测到您患糖尿病的风险为
                    <span v-if="healthReportInfo.dm_risk_ === 0">低</span>
                    <span v-else-if="healthReportInfo.dm_risk_ === 1">正常</span>
                    <span v-else-if="healthReportInfo.dm_risk_ === 2">高</span>。</li>
            </ul>
        </div>
        <div class="noPrintModel" style="height: 180px;"></div>
    </div>
    <!-- <div ref="wordFile" class="reportPage"></div> -->

    <div class="floatKuang noPrintModel">
        <p>请点击下面按钮后，在目标打印机中选择“另存为PDF”,点击保存后即可完成文件保存。</p>
        <el-button size="mini" @click="toSaveFile" type="primary">
            <span style="font-size: 14px;">保存为pdf文件</span>
        </el-button>
    </div>
</div>
</template>

<script>
import {
    getHealthyTestInfoNew
} from '@/api/evaluation/index.js';
export default {
    name:'healthReport',
    data(){
        return {
            healthReportInfo:{},
        }
    },
    created(){
        this.getInfo();
    },
    methods:{
        //获取详情
        getInfo(){
            let para = {
                id: this.$route.query.id,
            };
            getHealthyTestInfoNew(para).then(res=>{
                if(res.code == 200){
                    this.healthReportInfo = res.result;
                }
            })
        },
        //去保存
        toSaveFile(){
            window.print()
        },
    }
}
</script>

<style lang="scss" scoped>
h1{
    padding: 0px;
    margin: 0px;
}
.healthReportBox{
    position: relative;
    margin: 0;
    padding: 20px 0px;
    background-color: #f2f2f2;
    .reportPage{
        width: 190.5mm;
        min-height: 247mm;
        margin: auto;
        margin-bottom: 20px;
        box-shadow: 1px 1px 8px #e2e2e2;
        background-color: #fff;
    }
    .one_page{
        text-align: center;
        .fmTitle{
            padding-top: 150px;
            font-size: 26px;
            font-weight: 500;
            font-family: '宋体';
            color: #06a506;

            .rbTitText{
                display: flex;
                justify-content: center;
                align-items: flex-end;

                img{
                    width: 68px;
                    height: 68px;
                }
            }

            .englishText{
                font-size: 32px;
                margin-top: 5px;
            }
        }

        .infoTable{
            margin: 0px auto;
            margin-top: 120px;
            font-size: 20px;
            tr{
                font-family: '华文楷体';
                td{
                    padding: 10px;
                    box-sizing: border-box;
                }

                td:nth-child(1){
                    text-align: right;
                }

                td:nth-child(2){
                    width: 280px;
                    font-size: 18px;
                    border-bottom: 1px solid #000;
                    letter-spacing: 1px;
                }
            }
        }
    }
    .two_page{
        text-align: center;
        box-sizing: border-box;
        padding: 0px 45px;
        .modelTwoTit{
            padding: 50px 0px 20px 0px;
            font-family: '楷体';
            font-size: 26px;
            font-weight: bold;
            color: #06a506;
        }
        .modelItem{
            font-family: '楷体';
            padding-bottom: 20px;
            .itemTable{
                border-collapse: collapse;
                width: 100%;
                tr{
                    td{
                        font-size: 18px;
                        padding: 10px 5px;
                        border: 1px solid black;
                    }

                    .longText{
                        text-align: left !important;
                        line-height: 30px;
                        padding: 10px;
                    }
                }
            }
        }
    }
    .three_page{
        text-align: center;
        box-sizing: border-box;
        padding: 0px 45px;
        min-height: initial;
        .modelThreeTit{
            padding: 30px 0px 20px 0px;
            font-family: '楷体';
            font-size: 26px;
            font-weight: bold;
            color: #06a506;
        }
        .fxTable{
            border-collapse: collapse;
            border-spacing: 0;
            font-family: '楷体';
            width: 100%;
            tr{
                display: flex;
                td{
                    flex: 1;
                    font-size: 18px;
                    padding: 10px 5px;
                    border: 1px solid black;
                }

                .longText{
                    text-align: left !important;
                    line-height: 30px;
                    padding: 10px;
                }
            }
        }

        .suggestedText{
            padding-top: 20px;
            ul{
                text-align: left;
                li{
                    margin-bottom: 10px;
                    font-family: '楷体';
                    font-size: 17px;

                    span{
                        font-weight: bold;
                    }
                }
            }
        }
    }
}

.floatKuang{
    position: absolute;
    top: 50px;
    right: 50px;
    width: 200px;
    height: 200px;
    background-color: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: -1px 1px 5px 0px #f2f2f2;

    p{
        font-family: 'Arial';
        font-size: 14px;
        box-sizing: border-box;
        color: #1870aa;
        padding: 10px 20px;
    }
}

.showPrintModel{
    display: none;
}

@media print {
    @page {
        size: 210mm 297mm; /* or size: 794px 1123px; */
    }
    *,body,#app{
        padding: 0px;
        margin: 0px;
    }
    .healthReportBox{
        background-color: #fff;
    }
    .reportPage{
        box-shadow: none !important;
        margin-bottom: 0px !important;
    }
    .noPrintModel{
        display: none;
    }
    .showPrintModel{
        display: block;
    }
}
</style>